import Vue from "vue";
import App from "./App.vue";
import MugenScroll from "vue-mugen-scroll";

Vue.component("mugen-scroll", MugenScroll);

// import VueLazyload from "vue-lazyload";
 
// Vue.use(VueLazyload, {
//   preLoad: 1.5,
//   // error: 'dist/error.png',
//   // loading: 'dist/loading.gif',
//   attempt: 1
// })

import { VueMasonryPlugin } from "vue-masonry";

Vue.use(VueMasonryPlugin);

import PortalVue from 'portal-vue'

Vue.use(PortalVue)

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#masonry-app");
